var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPayPal = function SvgPayPal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#payPal_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    fill: "#fff",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0070E0",
    d: "M20.579 6.688c.164-1.048 0-1.761-.567-2.406-.624-.711-1.75-1.016-3.19-1.016h-4.185a.6.6 0 0 0-.59.506l-1.743 11.053a.36.36 0 0 0 .355.415h2.582l-.178 1.131a.32.32 0 0 0 .177.334q.061.03.13.03h2.178a.52.52 0 0 0 .513-.44l.022-.112.41-2.601.026-.147a.524.524 0 0 1 .517-.44h.326c2.108 0 3.76-.857 4.242-3.337.202-1.036.098-1.9-.435-2.509a2.1 2.1 0 0 0-.597-.46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001435",
    d: "M20.579 6.688c.164-1.048 0-1.761-.567-2.406-.624-.711-1.75-1.016-3.19-1.016h-4.185a.6.6 0 0 0-.59.506l-1.743 11.053a.36.36 0 0 0 .355.415h2.582l.65-4.116-.02.129a.596.596 0 0 1 .586-.506h1.228c2.41 0 4.298-.98 4.85-3.815q.023-.125.042-.245"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003087",
    d: "M14.587 6.702a.52.52 0 0 1 .52-.443h3.278a7 7 0 0 1 1.082.08 4 4 0 0 1 .536.118l.124.04q.235.075.454.19c.164-1.047 0-1.76-.567-2.405-.624-.711-1.75-1.016-3.191-1.016h-4.186a.6.6 0 0 0-.59.506l-1.743 11.053a.36.36 0 0 0 .355.415h2.582l.65-4.116z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "payPal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v20H0z"
  })))));
};
export default SvgPayPal;